import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=c7dcdde4&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=c7dcdde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dcdde4",
  null
  
)

export default component.exports